import React from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'

import routerSelectors from '@nocode-works/template/store/selectors/router'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(10),
  },
  paper: {
    padding: theme.spacing(2),
    width: '600px',
    margin: 'auto',
    textAlign: 'left',
  },
  button: {
    marginTop: theme.spacing(2),
  }
}))

const GoogleScopeWarning = ({

}) => {
  const classes = useStyles()
  const {type} = useSelector(routerSelectors.params)

  const onLogin = () => {
    const url = type == 'file' ?
      '/api/v1/auth/google_force_consent' :
      '/api/v1/auth/google_upgrade'
    document.location = url
  }

  return (
    <div className={ classes.root }>
      <Grid container spacing={ 10 }>
        <Grid item xs={ 12 } align="center">
          <Paper className={ classes.paper }>
            <Typography variant="h6" gutterBottom>
              Google Permissions Required
            </Typography>
            <Typography gutterBottom>
              We have detected that we don't have the required permissions to access your Google Drive.
              Please click the button below to login with Google and reactivate access to your Google Drive.
            </Typography>
            <Button
              className={ classes.button }
              variant="contained"
              color="secondary"
              onClick={ onLogin }
            >
              Login With Google
            </Button>
          </Paper>
        </Grid>
      </Grid>
    </div>
  )
}

export default GoogleScopeWarning